import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "components/buttons/Link";
import { useLivestreamMinutes } from "hooks/useLivestreamMinutes";
import { displayResetDate } from "helpers/time";
import styles from "./index.module.scss";

interface OutOfMinutesNoticeProps {
    className?: string;
    onLinkClick?: () => void;
}

export const OutOfMinutesNotice: React.FC<OutOfMinutesNoticeProps> = ({
    className,
    onLinkClick
}) => {
    const { i18n } = useTranslation();
    const { isOutOfMinutes, periodEnd } = useLivestreamMinutes();

    if (!isOutOfMinutes) return null;

    const resetDate = displayResetDate(periodEnd, i18n.language);

    return (
        <div
            role="status"
            className={`${styles["notice"]} ${className ?? ""}`}
        >
            <Trans
                i18nKey={
                    resetDate
                        ? "livestream-minutes:out-of-minutes"
                        : "livestream-minutes:out-of-minutes-no-date"
                }
                values={{ date: resetDate }}
                components={{
                    link1: (
                        <Link
                            to="/subscription#openModal"
                            onClick={onLinkClick}
                        />
                    )
                }}
            />
        </div>
    );
};
